<template>
  <DefaultLayout>
    <div class="container-nzidoo">
      <div class="faq-container">
        <h1>❓ Foire Aux Questions - NZIDOO 🇩🇿</h1>
        <p class="subtitle">Votre plateforme d'enchères moderne en Algérie.</p>

        <section class="faq-category">
          <h2 class="category-title">📘 Questions Générales</h2>

          <div class="accordion-group">
            <div v-for="faq in faqs" :key="faq.id" class="accordion-item">
              <button class="accordion-header">
                {{ faq.question }}
                <span class="icon">▼</span>
              </button>

              <div class="accordion-content">
                <p>{{ faq.answer }}</p>
              </div>
            </div>
          </div>
        </section>

        <p class="footer-note">
          Vous n'avez pas trouvé votre réponse ? Contactez notre support client.
        </p>
      </div>
    </div>
  </DefaultLayout>
</template>
<script>
import DefaultLayout from '@/layouts/DefaultLayout.vue';

export default {
  components: { DefaultLayout },

  data() {
    return {
      faqs: [],
    };
  },

  mounted() {
    this.getFaqs();
    this.initAccordion();
  },

  methods: {
    getFaqs() {
      this.$axios
        .get("faqs")
        .then((response) => {
          this.faqs=response.data;
          this.$nextTick(() => this.initAccordion());
        })
        .catch(() => { });
    },

    initAccordion() {
      const headers=document.querySelectorAll(".accordion-header");

      headers.forEach((header) => {
        header.onclick=function () {
          this.classList.toggle("active");

          const content=this.nextElementSibling;

          if (content.style.maxHeight) {
            content.style.maxHeight=null;
            content.style.paddingTop="0";
            content.style.paddingBottom="0";
          } else {
            content.style.maxHeight=content.scrollHeight+"px";
            content.style.paddingTop="15px";
            content.style.paddingBottom="15px";
          }

          const group=this.closest(".accordion-group");
          const others=group.querySelectorAll(".accordion-header");

          others.forEach((other) => {
            if (other!==this&&other.classList.contains("active")) {
              other.classList.remove("active");
              const oc=other.nextElementSibling;
              oc.style.maxHeight=null;
              oc.style.paddingTop="0";
              oc.style.paddingBottom="0";
            }
          });
        };
      });
    },
  },
};
</script>
<style scoped>
/* Container */
.faq-container {
  max-width: 1200px;
  margin: 40px auto;
  background-color: white;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

/* Title */
h1 {
  text-align: center;
  color: #004c46;
  font-size: 2.2em;
  margin-bottom: 5px;
}

.subtitle {
  text-align: center;
  color: #555;
  margin-bottom: 30px;
  font-size: 1.1em;
}

/* Category */
.category-title {
  color: #007bff;
  font-size: 1.6em;
  border-left: 5px solid #007bff;
  padding-left: 10px;
  margin-bottom: 20px;
}

/* Accordion */
.accordion-item {
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 10px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.accordion-header {
  background-color: #f9f9f9;
  color: #333;
  padding: 15px 20px;
  width: 100%;
  text-align: left;
  border: none;
  outline: none;
  cursor: pointer;
  font-size: 1.1em;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background-color 0.3s;
}

.accordion-header:hover,
.accordion-header.active {
  background-color: #e6f7ff;
  color: #007bff;
}

.icon {
  font-size: 1.2em;
  transition: transform 0.3s ease;
}

.accordion-header.active .icon {
  transform: rotate(180deg);
}

/* Content */
.accordion-content {
  max-height: 0;
  overflow: hidden;
  padding: 0 20px;
  background-color: white;
  transition: max-height 0.4s ease-out, padding 0.4s ease-out;
}

.accordion-content p {
  padding: 15px 0;
  margin: 0;
  color: #555;
}

/* Footer Note */
.footer-note {
  text-align: center;
  margin-top: 40px;
  padding-top: 20px;
  font-style: italic;
  color: #777;
  border-top: 1px solid var(--light);
}

/* Mobile */
@media (max-width: 768px) {
  .faq-container {
    margin: 20px auto;
    padding: 15px;
  }

  h1 {
    font-size: 1.8em;
  }

  .accordion-header {
    font-size: 1em;
    padding: 12px 15px;
  }
}
</style>
